/**
 * Coups de pouce — Attendu 1018 « Il sait coder des angles droits et des
 * longueurs égales. » (automatisme 6e).
 *
 * Une seule fiche PARTAGÉE par les quatre cartes (coder, placer, juste,
 * relier) : les deux codages et la règle « je code ce qui est écrit, pas ce
 * que je vois ». Exemple : triangle UVW tracé à main levée (angle en V
 * visiblement obtus, VW plus long que VU), énoncé « rectangle en V et
 * VU = VW » : le petit carré en V (orange), le même trait sur [VU] et [VW]
 * (vert). Lettres U, V, W hors du pool du générateur (ABCDEFGHKLMNPRST).
 */

const T = (x, y, s, couleur, poids = 700, taille = 11) => `<text x="${x}" y="${y}" font-size="${taille}" font-weight="${poids}" fill="${couleur}">${s}</text>`;
const PT = (p, label, dx, dy, couleur = '#1e293b') => `<circle cx="${p[0]}" cy="${p[1]}" r="2.6" fill="${couleur}"/><text x="${p[0] + dx}" y="${p[1] + dy}" font-family="system-ui,sans-serif" font-size="12.5" font-weight="800" fill="${couleur}">${label}</text>`;
const TICK = (a, b, n = 1, couleur = '#1e293b') => {
    const mx = (a[0] + b[0]) / 2; const my = (a[1] + b[1]) / 2; const dx = b[0] - a[0]; const dy = b[1] - a[1]; const L = Math.hypot(dx, dy); const ux = dx / L; const uy = dy / L; const nx = -uy * 6; const ny = ux * 6;
    let s = '';
    for (let k = 0; k < n; k++) { const t = (k - (n - 1) / 2) * 5; const cx = mx + ux * t; const cy = my + uy * t; s += `<line x1="${(cx + nx).toFixed(1)}" y1="${(cy + ny).toFixed(1)}" x2="${(cx - nx).toFixed(1)}" y2="${(cy - ny).toFixed(1)}" stroke="${couleur}" stroke-width="2.2"/>`; }
    return s;
};
/** Petit carré d'angle droit en V entre les directions vers P et Q. */
const DROIT = (V, P, Q, couleur = '#1e293b', c = 11) => {
    const u = (X) => { const dx = X[0] - V[0]; const dy = X[1] - V[1]; const L = Math.hypot(dx, dy); return [dx / L * c, dy / L * c]; };
    const a = u(P); const b = u(Q);
    return `<polyline points="${V[0] + a[0]},${V[1] + a[1]} ${V[0] + a[0] + b[0]},${V[1] + a[1] + b[1]} ${V[0] + b[0]},${V[1] + b[1]}" fill="none" stroke="${couleur}" stroke-width="1.8"/>`;
};

// ─── Triangle UVW à main levée : angle en V ≈ 109° (pas droit), VW ≈ 18 % plus long que VU ──
const U = [112, 88]; const V = [120, 220]; const W = [270, 262];
const TRI = `<polygon points="${U.join(',')} ${V.join(',')} ${W.join(',')}" fill="#dbeafe" fill-opacity="0.5" stroke="#1e293b" stroke-width="1.8"/>`;

const SVG_CODER = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 350" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Question : le triangle UVW est rectangle en V et VU = VW ; il est tracé à main levée. Comment le coder ? En 3 étapes à faire défiler avec les flèches. Étape 1 : le dessin n'est pas exact, l'angle en V ne paraît pas droit et VW paraît plus long que VU ; on ne code pas ce qu'on voit. Étape 2 : rectangle en V, le petit carré au sommet V. Étape 3 : VU = VW, le même petit trait sur le côté VU et sur le côté VW. Je code ce qui est écrit, pas ce que je vois.">
  <style>@keyframes cp1018-pop { from { opacity: 0; } to { opacity: 1; } } .cp1018-pop { opacity: 0; animation: cp1018-pop 0.5s ease forwards; }</style>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">Le dessin n'est pas exact</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="2" font-family="system-ui,sans-serif">L'angle droit : le petit carré</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="3" font-family="system-ui,sans-serif">Les longueurs égales : les mêmes traits</text>
  <g data-etape="1" font-family="system-ui,sans-serif">
    ${T(8, 44, 'Le triangle UVW est rectangle en V et VU = VW.', '#1E3A8A')}${T(8, 58, 'Il est tracé à main levée. Comment le coder ?', '#1E3A8A')}
    ${TRI}
    ${PT(U, 'U', -14, 2)}${PT(V, 'V', -14, 8)}${PT(W, 'W', 6, 10)}
    ${T(200, 110, 'L\'angle en V ne paraît', '#1E3A8A', 600)}${T(200, 124, 'pas droit, VW paraît', '#1E3A8A', 600)}${T(200, 138, 'plus long que VU :', '#1E3A8A', 600)}${T(200, 152, 'je ne code pas ce que je vois.', '#1E3A8A', 700)}
  </g>
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif"><g class="cp1018-pop">
    ${DROIT(V, U, W, '#B45309')}
    ${T(8, 296, 'Rectangle en V : le petit carré au sommet V.', '#B45309')}
  </g></g>
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif"><g class="cp1018-pop">
    ${TICK(V, U, 1, '#1D9E75')}${TICK(V, W, 1, '#1D9E75')}
    ${T(8, 314, 'VU = VW : le même petit trait sur [VU] et sur [VW].', '#1D9E75')}
    ${T(8, 338, 'Je code ce qui est écrit, pas ce que je vois.', '#1E3A8A', 800, 12.5)}
  </g></g>
</svg>`.trim();

const ENTREE = {
    pages: [
        {
            titre: 'La règle',
            lignes: [
                '**Le petit carré** au sommet : l\'angle est droit.',
                '**Les mêmes petits traits** sur deux côtés : ils ont la même longueur.',
                'Le sommet de l\'angle droit est la lettre du **milieu** : « rectangle en V », « l\'angle $\\widehat{UVW}$ est droit », « (UV) et (VW) sont perpendiculaires ».',
                '**Je code ce qui est écrit**, pas ce que je vois : une figure à main levée n\'est pas exacte.',
            ],
        },
        { titre: 'Un exemple', svg: SVG_CODER },
    ],
};

const CP_1018 = {
    coder_qcm_images: ENTREE,
    placer_qcm_unique: ENTREE,
    juste_tableau_vf: ENTREE,
    propriete_relier: ENTREE,
};

export default CP_1018;
